module.exports = __webpack_public_path__ + "static/media/fa-light-300.f1caac93.eot";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@athena-portal/themes/src/fonts/fontawesome/fa-light-300.eot
// module id = 529
// module chunks = 0